import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsPageComponent } from './details-page.component';
import { RouterModule, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpTranslateLoaderFactory } from 'app/app.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatGridListModule } from '@angular/material/grid-list';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ApplicationPipesModule } from '../applicationPipesModule.module';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@angular/flex-layout';

const routes: Routes = [
  {
      path:'order-details/:key',
      component: DetailsPageComponent,
  },
];


@NgModule({
  declarations: [DetailsPageComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatCardModule,
    // MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    FuseSharedModule ,
    // MatGridListModule,
    MatInputModule,
    MatDatepickerModule,
    MatGridListModule,
    MatNativeDateModule ,
    // MatStepperModule,
    CdkStepperModule,
    MatProgressBarModule,
    // MatProgressSpinnerModule,
    ApplicationPipesModule,
    LayoutModule,
    // MatRadioModule,
    // MatAutocompleteModule,
    HttpClientModule,
    FlexLayoutModule,
    // MatGridListModule,
    RouterModule.forChild(routes),
    TranslateModule.forRoot({
      loader: {
        
          provide: TranslateLoader,
          useFactory: httpTranslateLoaderFactory,
          deps: [HttpClient]
      }
      })
  ],
  exports: [DetailsPageComponent],
})
export class DetailsPageModule { }
